module.exports = __webpack_public_path__ + "dash_20_app_assets/img/Rating.39a04282.png";